import { z } from "zod";
import { surfaceEnvelope } from "./shared";

export const SkillSchema = z.object({ name: z.string(), frequency: z.number() }).passthrough();
export const DomainSchema = z.object({ name: z.string(), topic_count: z.number() }).passthrough();
export const ConversationStatsSchema = z.object({
  total_conversations: z.number(),
  total_tokens: z.number(),
  first_captured_at: z.string().nullish(),
  last_captured_at: z.string().nullish(),
}).passthrough();

export const IdentitySurfaceDataSchema = z.object({
  skills: z.array(SkillSchema).default([]),
  domains: z.array(DomainSchema).default([]),
  current_focus: z.array(z.string()).default([]),
  tools_used: z.array(z.string()).default([]),
  conversation_stats: ConversationStatsSchema,
}).passthrough();

export const IdentitySurfaceResponseSchema = surfaceEnvelope(IdentitySurfaceDataSchema);

export type Skill = z.infer<typeof SkillSchema>;
export type Domain = z.infer<typeof DomainSchema>;
export type ConversationStats = z.infer<typeof ConversationStatsSchema>;
export type IdentitySurfaceData = z.infer<typeof IdentitySurfaceDataSchema>;
export type IdentitySurfaceResponse = z.infer<typeof IdentitySurfaceResponseSchema>;
